const isUrlAbsolute = (url: string) => url.indexOf('://') > 0 || url.startsWith('//');

export default isUrlAbsolute;
